require('fast-text-encoding'); // Dynamic polyfill

export default class ByteEncoder {
  public static bytesToString(byteArray: Uint8Array): string {
    return (new TextDecoder().decode(byteArray));
  }

  public static stringToBytes(stringValue: string): Uint8Array {
    return (new TextEncoder().encode(stringValue));
  }
}
